import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import AtendimentoPanel from "./AtendimentoPanel";

export default function AtendimentoPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [appt, setAppt] = useState(null);
  const [board, setBoard] = useState(null);

  const backRoute = user?.role === "professional" ? "/admin/minha-agenda" : "/admin/fluxo";

  useEffect(() => {
    let cancelled = false;
    api.get(`/admin/appointments/${id}`)
      .then(r => { if (!cancelled) setAppt(r.data); })
      .catch(() => { toast.error("Agendamento não encontrado"); navigate(backRoute, { replace: true }); });
    api.get("/admin/appointments/board")
      .then(r => { if (!cancelled) setBoard(r.data); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [id]); // eslint-disable-line

  const handleNext = async (currentAppt) => {
    // marca atual como concluído
    try { await api.put(`/admin/appointments/${currentAppt.id}`, { status: "completed" }); } catch {}

    // busca board atualizado
    let freshBoard = null;
    try { freshBoard = (await api.get("/admin/appointments/board")).data; } catch {}
    freshBoard = freshBoard || board;

    if (!freshBoard) { toast.info("Nenhum próximo agendamento"); navigate(backRoute); return; }

    const candidates = ["pending", "confirmed"]
      .flatMap(c => freshBoard.columns?.[c] || [])
      .sort((a, b) =>
        (a.scheduled_time || a.time || "").localeCompare(b.scheduled_time || b.time || "")
      );

    const curTime = currentAppt.time || currentAppt.scheduled_time || "";
    const next = candidates.find(a =>
      (a.scheduled_time || a.time || "") > curTime && a.id !== currentAppt.id
    );

    if (next) {
      navigate(`/admin/atendimento/${next.id}`);
    } else {
      toast.info("Nenhum próximo agendamento");
      navigate(backRoute);
    }
  };

  if (!appt) {
    return (
      <div style={{minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",background:"#fafbfc"}}>
        <div style={{width:32,height:32,border:"2px solid #f59e0b",borderTopColor:"transparent",borderRadius:"50%",animation:"spin .7s linear infinite"}}/>
        <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
      </div>
    );
  }

  return (
    <AtendimentoPanel
      appt={appt}
      board={board}
      onClose={() => navigate(backRoute)}
      onComplete={(a) => api.put(`/admin/appointments/${a.id}`, { status: "completed" }).catch(() => {})}
      onNext={handleNext}
    />
  );
}
